

export interface SunEditorEnvironment {
  /** The node the editor textarea is rendered in. */
  root: Node | null | undefined;
  /** `typeof ShadowRoot.prototype.getSelection === 'function'` */
  hasShadowRootGetSelection: boolean;
  userAgent: string;
}

/** Heights are fixed in iframe mode; the iframe scrolls internally and can be resized by hand. */
export const SUN_EDITOR_IFRAME_HEIGHT = '240px';


export function fillSunEditorIframe(editor: any): void {
  const frame: HTMLIFrameElement | undefined = editor?.core?.context?.element?.wysiwygFrame;
  const body = frame?.contentDocument?.body;
  if (!body) {
    return;
  }
  body.style.minHeight = '100vh';
  body.style.boxSizing = 'border-box';
}

export function readSunEditorEnvironment(root: Node | null | undefined): SunEditorEnvironment {
  const hasShadowRoot = typeof ShadowRoot === 'function';
  return {
    root,
    hasShadowRootGetSelection:
      hasShadowRoot && typeof (ShadowRoot.prototype as any).getSelection === 'function',
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent || '' : '',
  };
}


export function shouldUseSunEditorIframe(env: SunEditorEnvironment): boolean {
  if (typeof ShadowRoot !== 'function' || !(env.root instanceof ShadowRoot)) {
    return false;
  }
  if (env.hasShadowRootGetSelection) {
    return false;
  }
  return !/Firefox\//i.test(env.userAgent);
}
